// Basic Setup ↓
import './components/_1_collapse.js';
import './components/_1_custom-select.js';
import './components/_1_details.js';
import './components/_1_diagonal-movement.js';
import './components/_1_modal-window.js';
import './components/_1_read-more.js';
import './components/_1_reveal-effects.js';
import './components/_1_swipe-content.js';
import './components/_1_tabs.js';
import './components/_2_carousel.js';
import './components/_2_dropdown.js';
import './components/_2_points-of-interest.js';
import './components/_2_slideshow.js';
import './components/_1_countdown.js';


// Navigations ↓
import './components/_1_anim-menu-btn.js';
import './components/_2_flexi-header.js';
import './components/_3_mega-site-navigation.js';
import './components/_1_drawer.js';
import './components/_2_drawer-navigation.js';


// Components ↓
import '../../components/accordion-v2/script.js'; import '../../components/accordion/script.js'; import '../../components/animated-gallery/script.js'; import '../../components/image-comparison/script.js'; import '../../components/image-hotspots/script.js'; import '../../components/logo-ticker/script.js'; import '../../components/masonry-gallery/script.js'; import '../../components/number-counter/script.js';


// WooCommerce ↓
// import './includes/_1_woocommerce.js';


document.addEventListener('DOMContentLoaded', () => {
    const hasHero = document.querySelector('main > section > div > div > div.component-hero');

    if(!hasHero) {
        const header = document.querySelector('header');
        header.classList.add('bg');
    }
});